import React from "react";
import "./components.css";
const Loader = () => {
  return (
    <>
      <div className="loader"> </div>
      <p className="text-center">
        Crunching the latest articles, just for you. Hang tight…
      </p>
    </>
  );
};

export default Loader;
